// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  adminToggle: false,
  items: [
    {
      title: 'Dashboard',
      icon: 'mdi-view-dashboard',
      to: '/dashboard/',
    },
    {
      title: 'Contracts',
      icon: 'mdi-clipboard-outline',
      to: '/contracts/',
    },
    {
      title: 'Software',
      icon: 'mdi-apps',
      to: '/software/',
    },
    {
      title: 'Problems',
      icon: 'mdi-bug-outline',
      to: '/problems/',
    },
    {
      title: 'Profile',
      icon: 'mdi-account-outline',
      to: '/profile/',
    },
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  // eslint-disable-next-line
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
